var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3332 1C14.9282 1 18.6665 4.73833 18.6665 9.33333C18.6665 13.9283 14.9282 17.6667 10.3332 17.6667C5.73821 17.6667 1.99988 13.9283 1.99988 9.33333C1.99988 4.73833 5.73821 1 10.3332 1ZM10.3332 2.25C6.42738 2.25 3.24988 5.4275 3.24988 9.33333C3.24988 13.2392 6.42738 16.4167 10.3332 16.4167C14.239 16.4167 17.4165 13.2392 17.4165 9.33333C17.4165 5.4275 14.239 2.25 10.3332 2.25ZM10.0509 5.24617C10.3967 5.24617 10.6759 5.52617 10.6759 5.87117V9.55617L13.5134 11.2478C13.8092 11.4253 13.9067 11.8087 13.73 12.1053C13.6125 12.3012 13.405 12.4103 13.1925 12.4103C13.0834 12.4103 12.9734 12.382 12.8725 12.3228L9.73088 10.4487C9.54254 10.3353 9.42588 10.1312 9.42588 9.91117V5.87117C9.42588 5.52617 9.70588 5.24617 10.0509 5.24617Z",
    fill: "#1B2E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/IconClock.9cc3da13eacb2deba5e00f9d1ea17f81.svg";
export { ForwardRef as ReactComponent };